import { createSlice } from '@reduxjs/toolkit';

export const additionItems = createSlice({
  name: 'additionItems',
  initialState: {
    data: [],
  },

  reducers: {
    setAdditionItems: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAdditionItems } = additionItems.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getAdditionItems = (state) => state.additionItems.data;

export default additionItems.reducer;
